import * as SCREEN from '@screen';
import MainSideBar from '@navigation/layouts/MainSidebar';

export const notFoundPath = '/login';
export const notAllowed = '/home';
export const notAllowedOnus = '/transactions';
export const loginPath = '/login';
export const homeLogged = '/home';
export const routes = [
  {
    name: 'LOGIN',
    path: '/login',
    showOnNav: false,
    component: SCREEN.LoginForm,
  },
  {
    name: 'ACCOUNT_CREATED',
    path: '/account-created',
    showOnNav: false,
    component: SCREEN.AccountCreated,
  },
  {
    name: 'FORGOT_PASSWORD',
    path: '/forgot-password',
    showOnNav: false,
    component: SCREEN.EmailReset,
  },
  {
    name: 'USER_RECOVERY',
    path: '/user-recovery',
    showOnNav: false,
    component: SCREEN.UserRecovery,
  },
  {
    name: 'RESET_PASSWORD',
    path: '/reset-password',
    showOnNav: false,
    component: SCREEN.ResetPasswordForm,
  },
  {
    name: 'RESET_PASSWORD',
    path: '/reset-password-invitation',
    showOnNav: false,
    component: SCREEN.ResetPasswordInvitation,
  },
  {
    name: 'CREATE_PASSWORD_ANDES',
    path: '/create-password-tyc-andes',
    showOnNav: false,
    component: SCREEN.CreatePasswordAndes,
  },
  {
    name: 'RESET_PASSWORD_SUCCESS',
    path: '/success-reset-password',
    showOnNav: false,
    component: SCREEN.SuccessResetPassword,
  },
  {
    name: 'EMAIL_SENT',
    path: '/email-sent',
    showOnNav: false,
    component: SCREEN.EmailSentForm,
  },
  {
    name: 'HOME',
    path: '/home',
    title: '',
    icon: 'home',
    showOnNav: true,
    private: true,
    nameOnNav: 'routes.home.nameOnNav',
    layout: MainSideBar,
    // onlySeller: false,
    component: SCREEN.HomeScreen,
  },
  {
    name: 'MOVEMENTS',
    path: '/movements',
    title: 'routes.movement.title',
    icon: 'movements',
    showOnNav: false,
    nameOnNav: 'routes.movement.nameOnNav',
    private: true,
    layout: MainSideBar,
    onlySeller: true,
    component: SCREEN.HomeScreen,
  },
  {
    name: 'TRANSACTIONS',
    path: '/transactions',
    title: 'transactions.title',
    description: 'transactions.description',
    icon: 'transactions',
    showOnNav: true,
    private: true,
    layout: MainSideBar,
    onlySeller: false,
    component: SCREEN.Transactions,
    routes: [
      {
        name: 'REFUND',
        path: '/refund',
        title: 'transactions.title',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.TransactionDetail,
        layoutProps: {
          mobileFullSize: true,
        },
      },
      {
        name: 'REFUND_SUCCESS',
        path: '/refund-success',
        title: 'transactions.detail.title',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.SuccessRefund,
      },
      {
        name: 'REFUND_ERROR',
        path: '/refund-error',
        title: 'transactions.detail.title',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.ErrorRefund,
      },
    ],
  },
  {
    name: 'LAST_MOVEMENTS',
    path: '/last-movements',
    icon: 'movements',
    title: 'lastMovements.title',
    description: 'lastMovements.description',
    showOnNav: true,
    layout: MainSideBar,
    private: true,
    component: SCREEN.LastMovements,
  },
  {
    name: 'SETTLEMENT_CALENDAR',
    path: '/settlement-calendar',
    icon: 'calendar',
    title: 'settlementCalendar.title',
    description: 'settlementCalendar.description',
    showOnNav: true,
    layout: MainSideBar,
    private: true,
    component: SCREEN.SettlementCalendar,
  },
  {
    name: 'WITHDRAW',
    path: '/funds-out',
    title: 'paymentsFoundsOut.title',
    description: 'paymentsFoundsOut.description',
    icon: 'founds-out',
    showOnNav: true,
    private: true,
    layout: MainSideBar,
    component: SCREEN.FoundsOut,
    routes: [
      {
        // A deprecar: esta ruta queda para retrocompatibilidad
        name: 'WITHDRAW_CREATE_BANK_ACCOUNT',
        path: '/add',
        title: 'paymentsFoundsOut.common.bankAccount',
        titleMobile: 'paymentsFoundsOut.addBankAccount.titleMobile',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.AddBankAccount,
      },
      {
        name: 'WITHDRAW_DO',
        path: '/do',
        title: 'paymentsFoundsOut.doFundsOut.title',
        titleMobile: 'paymentsFoundsOut.doFundsOut.titleMobile',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.DoFoundsOut,
      },
      {
        name: 'WITHDRAW_CHECK',
        path: '/check',
        title: 'paymentsFoundsOut.doFundsOut.title',
        titleMobile: 'paymentsFoundsOut.doFundsOut.titleMobile',
        showOnNav: false,
        private: false,
        layout: MainSideBar,
        component: SCREEN.FoundsOutCheck,
      },
      {
        name: 'WITHDRAW_SUCCESS',
        path: '/success',
        title: 'paymentsFoundsOut.title',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.SuccessFoundsOut,
      },
      {
        name: 'WITHDRAW_ERROR',
        path: '/error',
        title: 'paymentsFoundsOut.error.title',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.ErrorFundsout,
      },
      {
        name: 'WITHDRAW_MODIFY_BANK_ACCOUNT',
        path: '/bank-account-edit',
        title: 'paymentsFoundsOut.title',
        titleMobile: 'paymentsFoundsOut.editBankAccount.titleMobile',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.EditBankAccount,
        layoutProps: {
          mobileFullSize: true,
        },
      },
      {
        name: 'WITHDRAW_CREATE_BANK_ACCOUNT',
        path: '/bank-account-add',
        title: 'paymentsFoundsOut.title',
        titleMobile: 'paymentsFoundsOut.addBankAccount.titleMobile',
        showOnNav: false,
        private: true,
        layout: MainSideBar,
        component: SCREEN.AddBankAccount,
        layoutProps: {
          mobileFullSize: true,
        },
      },
    ],
  },
  {
    name: 'REPORTS',
    path: '/reports',
    icon: 'document',
    title: 'reportsScreen.title',
    description: 'reportsScreen.description',
    showOnNav: true,
    private: true,
    layout: MainSideBar,
    onlySeller: false,
    component: SCREEN.Reports,
  },
  {
    name: 'FINANCE',
    path: '/finance',
    showOnNav: true,
    layout: MainSideBar,
    title: 'finance.title',
    titleMobile: 'finance.titleMobile',
    description: 'finance.description',
    icon: 'library',
    private: true,
    component: SCREEN.SellerCreditFacility,
    htmlId: 'financing-menu-btn-link',
    showBullet: true,
  },
  {
    name: 'CONFIGURATION',
    path: '/configuration',
    icon: 'configuration',
    title: 'configuration.title',
    showOnNav: false,
    notBreadcrumb: true,
    private: true,
    layout: MainSideBar,
    component: SCREEN.UserList,
    routes: [
      {
        name: 'DOCUMENTS',
        path: '/documentation',
        title: 'documentation.title',
        showOnNav: true,
        private: true,
        layout: MainSideBar,
        component: SCREEN.Document,
      },
      {
        name: 'USERS',
        path: '/users',
        title: 'users.title',
        showOnNav: true,
        private: true,
        layout: MainSideBar,
        onlySeller: false,
        component: SCREEN.UserList,
        routes: [
          {
            name: 'USERS_EDIT',
            path: '/detail',
            title: 'users.detail.title',
            showOnNav: false,
            private: true,
            component: SCREEN.UserDetail,
            layout: MainSideBar,
            layoutProps: {
              mobileFullSize: true,
            },
            routes: [
              {
                name: 'USERS_UPDATE_PROFILE',
                path: '/edit-name',
                title: 'editname.title',
                showOnNav: true,
                private: true,
                component: SCREEN.UserNameEdit,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
              {
                name: 'USERS_UPDATE_PROFILE',
                path: '/edit-document-number',
                title: 'editDocumentNumber.title',
                showOnNav: true,
                private: true,
                component: SCREEN.UserDocumentNumberEdit,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
              {
                name: 'USERS_UPDATE_PHONES',
                path: '/edit-phone-number',
                title: 'editPhoneNumber.title',
                showOnNav: true,
                private: true,
                component: SCREEN.UserPhoneNumberEdit,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
              {
                name: 'USERS_UPDATE_PROFILE',
                path: '/edit-role',
                title: 'navsTitle.editRole',
                showOnNav: true,
                private: true,
                component: SCREEN.UserRoleEdit,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
              {
                name: 'USERS_UPDATE_PROFILE',
                path: '/edit-role-error',
                title: 'users.title',
                showOnNav: false,
                private: true,
                component: SCREEN.GenericError,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
              {
                name: 'USERS_EDIT',
                path: '/edit',
                title: 'editCollaborator.title',
                showOnNav: true,
                private: true,
                component: SCREEN.UserEdit,
                layout: MainSideBar,
                layoutProps: {
                  mobileFullSize: true,
                },
              },
            ],
          },
          {
            name: 'USERS_INVITE_FORM',
            path: '/invite-form',
            title: 'users.title',
            showOnNav: false,
            private: true,
            component: SCREEN.UserInviteForm,
            layout: MainSideBar,
            layoutProps: {
              mobileFullSize: true,
            },
          },
          {
            name: 'USERS_INVITE_FORM_ROLES',
            path: '/invite-roles',
            title: 'users.title',
            showOnNav: false,
            private: true,
            component: SCREEN.UserInviteRoles,
            layout: MainSideBar,
            layoutProps: {
              mobileFullSize: true,
            },
          },
        ],
      },
      {
        name: 'MERCHANT_ACCOUNT',
        path: '/commerce-info',
        title: 'commerceData.title',
        showOnNav: true,
        layout: MainSideBar,
        private: true,
        component: SCREEN.CommerceData,
        routes: [
          {
            name: 'MERCHANT_UPDATE',
            path: '/edit',
            title: 'commerceData.editCommerce.title',
            showOnNav: false,
            private: true,
            layout: MainSideBar,
            component: SCREEN.EditCommerce,
          },
          {
            name: 'MERCHANT_UPDATE',
            path: '/representant-edit',
            title: 'commerceData.editRepresentant.title',
            showOnNav: false,
            private: true,
            layout: MainSideBar,
            component: SCREEN.EditRepresentant,
          },
          {
            name: 'WITHDRAW_MODIFY_BANK_ACCOUNT',
            path: '/bank-account-edit',
            title: 'commerceData.title',
            titleMobile: 'paymentsFoundsOut.editBankAccount.titleMobile',
            showOnNav: false,
            private: true,
            layout: MainSideBar,
            component: SCREEN.EditBankAccount,
            layoutProps: {
              mobileFullSize: true,
            },
          },
          {
            name: 'WITHDRAW_CREATE_BANK_ACCOUNT',
            path: '/bank-account-add',
            titleMobile: 'paymentsFoundsOut.addBankAccount.titleMobile',
            title: 'commerceData.title',
            showOnNav: false,
            private: true,
            layout: MainSideBar,
            component: SCREEN.AddBankAccount,
            layoutProps: {
              mobileFullSize: true,
            },
          },
        ],
      },
    ],
  },
];
